import { T as p } from "./index.es25.js";
import { i as c } from "./index.es38.js";
import { e as u } from "./index.es39.js";
var r = p, s = {
  input: !0,
  option: !0,
  optgroup: !0,
  select: !0,
  button: !0,
  datalist: !0,
  textarea: !0
}, a = {
  tr: { tr: !0, th: !0, td: !0 },
  th: { th: !0 },
  td: { thead: !0, th: !0, td: !0 },
  body: { head: !0, link: !0, script: !0 },
  li: { li: !0 },
  p: { p: !0 },
  h1: { p: !0 },
  h2: { p: !0 },
  h3: { p: !0 },
  h4: { p: !0 },
  h5: { p: !0 },
  h6: { p: !0 },
  select: s,
  input: s,
  output: s,
  button: s,
  datalist: s,
  textarea: s,
  option: { option: !0 },
  optgroup: { optgroup: !0 }
}, n = {
  __proto__: null,
  area: !0,
  base: !0,
  basefont: !0,
  br: !0,
  col: !0,
  command: !0,
  embed: !0,
  frame: !0,
  hr: !0,
  img: !0,
  input: !0,
  isindex: !0,
  keygen: !0,
  link: !0,
  meta: !0,
  param: !0,
  source: !0,
  track: !0,
  wbr: !0
}, h = {
  __proto__: null,
  math: !0,
  svg: !0
}, _ = {
  __proto__: null,
  mi: !0,
  mo: !0,
  mn: !0,
  ms: !0,
  mtext: !0,
  "annotation-xml": !0,
  foreignObject: !0,
  desc: !0,
  title: !0
}, l = /\s|\//;
function e(t, i) {
  this._options = i || {}, this._cbs = t || {}, this._tagname = "", this._attribname = "", this._attribvalue = "", this._attribs = null, this._stack = [], this._foreignContext = [], this.startIndex = 0, this.endIndex = null, this._lowerCaseTagNames = "lowerCaseTags" in this._options ? !!this._options.lowerCaseTags : !this._options.xmlMode, this._lowerCaseAttributeNames = "lowerCaseAttributeNames" in this._options ? !!this._options.lowerCaseAttributeNames : !this._options.xmlMode, this._options.Tokenizer && (r = this._options.Tokenizer), this._tokenizer = new r(this._options, this), this._cbs.onparserinit && this._cbs.onparserinit(this);
}
c(e, u.EventEmitter);
e.prototype._updatePosition = function(t) {
  this.endIndex === null ? this._tokenizer._sectionStart <= t ? this.startIndex = 0 : this.startIndex = this._tokenizer._sectionStart - t : this.startIndex = this.endIndex + 1, this.endIndex = this._tokenizer.getAbsoluteIndex();
};
e.prototype.ontext = function(t) {
  this._updatePosition(1), this.endIndex--, this._cbs.ontext && this._cbs.ontext(t);
};
e.prototype.onopentagname = function(t) {
  if (this._lowerCaseTagNames && (t = t.toLowerCase()), this._tagname = t, !this._options.xmlMode && t in a)
    for (var i; (i = this._stack[this._stack.length - 1]) in a[t]; this.onclosetag(i)) ;
  (this._options.xmlMode || !(t in n)) && (this._stack.push(t), t in h ? this._foreignContext.push(!0) : t in _ && this._foreignContext.push(!1)), this._cbs.onopentagname && this._cbs.onopentagname(t), this._cbs.onopentag && (this._attribs = {});
};
e.prototype.onopentagend = function() {
  this._updatePosition(1), this._attribs && (this._cbs.onopentag && this._cbs.onopentag(this._tagname, this._attribs), this._attribs = null), !this._options.xmlMode && this._cbs.onclosetag && this._tagname in n && this._cbs.onclosetag(this._tagname), this._tagname = "";
};
e.prototype.onclosetag = function(t) {
  if (this._updatePosition(1), this._lowerCaseTagNames && (t = t.toLowerCase()), (t in h || t in _) && this._foreignContext.pop(), this._stack.length && (!(t in n) || this._options.xmlMode)) {
    var i = this._stack.lastIndexOf(t);
    if (i !== -1)
      if (this._cbs.onclosetag)
        for (i = this._stack.length - i; i--; ) this._cbs.onclosetag(this._stack.pop());
      else this._stack.length = i;
    else t === "p" && !this._options.xmlMode && (this.onopentagname(t), this._closeCurrentTag());
  } else !this._options.xmlMode && (t === "br" || t === "p") && (this.onopentagname(t), this._closeCurrentTag());
};
e.prototype.onselfclosingtag = function() {
  this._options.xmlMode || this._options.recognizeSelfClosing || this._foreignContext[this._foreignContext.length - 1] ? this._closeCurrentTag() : this.onopentagend();
};
e.prototype._closeCurrentTag = function() {
  var t = this._tagname;
  this.onopentagend(), this._stack[this._stack.length - 1] === t && (this._cbs.onclosetag && this._cbs.onclosetag(t), this._stack.pop());
};
e.prototype.onattribname = function(t) {
  this._lowerCaseAttributeNames && (t = t.toLowerCase()), this._attribname = t;
};
e.prototype.onattribdata = function(t) {
  this._attribvalue += t;
};
e.prototype.onattribend = function() {
  this._cbs.onattribute && this._cbs.onattribute(this._attribname, this._attribvalue), this._attribs && !Object.prototype.hasOwnProperty.call(this._attribs, this._attribname) && (this._attribs[this._attribname] = this._attribvalue), this._attribname = "", this._attribvalue = "";
};
e.prototype._getInstructionName = function(t) {
  var i = t.search(l), o = i < 0 ? t : t.substr(0, i);
  return this._lowerCaseTagNames && (o = o.toLowerCase()), o;
};
e.prototype.ondeclaration = function(t) {
  if (this._cbs.onprocessinginstruction) {
    var i = this._getInstructionName(t);
    this._cbs.onprocessinginstruction("!" + i, "!" + t);
  }
};
e.prototype.onprocessinginstruction = function(t) {
  if (this._cbs.onprocessinginstruction) {
    var i = this._getInstructionName(t);
    this._cbs.onprocessinginstruction("?" + i, "?" + t);
  }
};
e.prototype.oncomment = function(t) {
  this._updatePosition(4), this._cbs.oncomment && this._cbs.oncomment(t), this._cbs.oncommentend && this._cbs.oncommentend();
};
e.prototype.oncdata = function(t) {
  this._updatePosition(1), this._options.xmlMode || this._options.recognizeCDATA ? (this._cbs.oncdatastart && this._cbs.oncdatastart(), this._cbs.ontext && this._cbs.ontext(t), this._cbs.oncdataend && this._cbs.oncdataend()) : this.oncomment("[CDATA[" + t + "]]");
};
e.prototype.onerror = function(t) {
  this._cbs.onerror && this._cbs.onerror(t);
};
e.prototype.onend = function() {
  if (this._cbs.onclosetag)
    for (var t = this._stack.length; t > 0; this._cbs.onclosetag(this._stack[--t])) ;
  this._cbs.onend && this._cbs.onend();
};
e.prototype.reset = function() {
  this._cbs.onreset && this._cbs.onreset(), this._tokenizer.reset(), this._tagname = "", this._attribname = "", this._attribs = null, this._stack = [], this._cbs.onparserinit && this._cbs.onparserinit(this);
};
e.prototype.parseComplete = function(t) {
  this.reset(), this.end(t);
};
e.prototype.write = function(t) {
  this._tokenizer.write(t);
};
e.prototype.end = function(t) {
  this._tokenizer.end(t);
};
e.prototype.pause = function() {
  this._tokenizer.pause();
};
e.prototype.resume = function() {
  this._tokenizer.resume();
};
e.prototype.parseChunk = e.prototype.write;
e.prototype.done = e.prototype.end;
var d = e;
export {
  d as P
};
//# sourceMappingURL=index.es23.js.map
